import { trackSuburb } from '@store/index'
import { useSetRecoilState, useRecoilValue } from 'recoil'
import { useCallback } from 'react'
import { trackDataLayer } from '@plugin/google/gtm/modules/suburb'

export default function useTrackSuburb() {

  const state = useRecoilValue(trackSuburb)
  const setTrackSuburbState = useSetRecoilState(trackSuburb)

  // 认领房源
  const showTrackSuburb = useCallback(({ suburb, signupSource }) => {
    return event => {
      event.preventDefault()
      event.stopPropagation()
      trackDataLayer.click()
      trackDataLayer.show()
      setTrackSuburbState(d => ({ ...d, show: true, suburb, signupSource }))
    }
  }, [setTrackSuburbState])

  // 修改suburb数据
  const changeSuburb = useCallback(suburb => {
    setTrackSuburbState(d => ({ ...d, suburb }))
  }, [setTrackSuburbState])

  // tracking
  const toggleTracking = useCallback(tracking => {
    setTrackSuburbState(d => ({ ...d, tracking }))
  }, [setTrackSuburbState])

  // 隐藏track
  const hideTrackSuburb = useCallback(() => {
    setTrackSuburbState(d => ({ ...d, show: false }))
  }, [setTrackSuburbState])

  return {
    ...state,
    showTrackSuburb,
    changeSuburb,
    toggleTracking,
    hideTrackSuburb
  }
}